export default __webpack_public_path__ + "6c8ff56e00c4d5fea46a0d587a0bc2bf.png";